import { MicrophoneQuestionOutlineIcon } from './MicrophoneQuestionOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 89B1E3B0-1970-4ACC-B2DC-B45DFC33DE4B
 * name microphone-question-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-question-outline.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MicrophoneHelpOutlineIcon = MicrophoneQuestionOutlineIcon;
export default MicrophoneHelpOutlineIcon